import { Container, Row, Col, Button } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const Demo = () => {
  return (
    <Container fluid className="p-5">
      <Helmet>
        <title>Demo - QuickyChat</title>
        <meta name="description" content="Watch the demo to see how easy it is to create, customize, and deploy your own AI chatbot using our platform." />
        <meta name="keywords" content="AI chatbot, demo, QuickyChat, create chatbot, customize chatbot, deploy chatbot" />
      </Helmet>
      {/* Title and Description */}
      <Row className="mb-4 text-center">
        <Col>
          <h1 className="mb-3">Explore Our App in Action</h1>
          <p>
            Watch the demo to see how easy it is to create, customize, and deploy your own AI chatbot
            using our platform.
          </p>
        </Col>
      </Row>

      {/* Video Embed */}
      <Row className="justify-content-center mb-4">
        <Col md={8}>
          <div className="ratio ratio-16x9">
            <iframe
              src="https://www.youtube.com/embed/YOUR_VIDEO_ID"
              title="Demo Video"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
              style={{ border: 'none' }}
            ></iframe>
          </div>
        </Col>
      </Row>

      {/* Call to Action */}
      <Row className="text-center py-5">
        <Col>
          <h3 className="mb-3">Ready to Get Started?</h3>
          <p>
            Sign up today and begin creating intelligent, customized AI chatbots that work for you.
          </p>
          <Link to="/dashboard">
				<Button variant="primary" size="lg">
					Start Building for Free
				</Button>
			</Link>
        </Col>
      </Row>
    </Container>
  );
};

export default Demo;
